module.exports = __webpack_public_path__ + "static/media/nav_house.d3f2962a.svg";